import { createFileRoute, useParams } from '@tanstack/react-router'
import { Pencil } from 'lucide-react'
import { useBlogPost, useUpdateBlog } from '@/hooks/data/useBlog'
import BlogEditorForm from '@/components/blog/BlogEditorForm'

function EditBlogPostPage() {
  const { id } = useParams({ strict: false }) as { id: string }
  const post = useBlogPost(id)
  const update = useUpdateBlog()

  if (post.isLoading) return <p className="p-6 text-gray-500">Loading post…</p>
  if (post.isError || !post.data) return <p className="p-6 text-red-600">Failed to load post — requires the manager role, or it doesn't exist.</p>

  return (
    <div className="p-2 md:p-4 space-y-4">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white flex items-center gap-2">
        <Pencil className="w-6 h-6" /> Edit Blog Post
      </h1>
      <BlogEditorForm
        initial={post.data}
        submitLabel="Save"
        onSubmit={async (input) => {
          await update.mutateAsync({ id, body: input })
        }}
      />
    </div>
  )
}

export const Route = createFileRoute('/(admin)/blog/$id/')({
  component: EditBlogPostPage,
})
